import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Radio": Radio, "@mui/material/RadioGroup": RadioGroup, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/FormControl": FormControl, "@mui/material/FormHelperText": FormHelperText, "@mui/material/FormLabel": FormLabel, "@mui/material/Button": Button } } });
export default ClientProvider;
